import "./Publication.css";

export default function Publication({ pubContent }) {
  return (
    <div className="publication">
      <a href={pubContent.pubLink}>
        <h1>{pubContent.pubName}</h1>
      </a>
      {pubContent.pubDescription.map((info) => (
        <p>{info}</p>
      ))}
    </div>
  );
}
